import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.jsx'
import { ConfigProvider } from 'antd';

createRoot(document.getElementById('root')).render(
    <ConfigProvider
        direction='ltr'
        componentSize='middle'
        theme={{
            token: {
                colorPrimary: '#e27e56',
            },
        }}
    >
            <App />
    </ConfigProvider>
)
